import { z } from '@harvestiq/zod';

export const getFaqByIdParamsSchema = z.object({
  faqId: z.string().uuid(),
});
export type GetFaqByIdSchemaParams = z.infer<typeof getFaqByIdParamsSchema>;
